import React from 'react';
import { Redirect } from 'react-router-dom';
import { FeatureToggle, PageNotFound } from '@components/common';
import {
  CustomDashboard,
  WithResetTrends,
  WithPersistence,
  WithModifyComparison,
  AppExperience,
  TempAppExperienceDrilldown,
  WebhooksListPage,
  WebhooksEditPage,
  ErrorDiagnosticsSharing,
  TempDashboardErrorDiagnostics,
  DashboardErrorDiagnostics,
  TempTimeline,
  TimelineSharing,
  SavedTimeline,
  NocContainer,
  MLContainer,
  NocSharing,
  DashboardNoc,
  TempDashboardNoc,
  NocSavedDashboard,
  ServiceIntegrations,
  AiAlertsDashboard,
  ViewerModule,
  OverviewDashboard,
  AppTimeline,
  ResiliencyDashboard,
  Sankey,
  Funnel,
} from '../pages';
import { PAGE_TYPE } from '@utils/constants';
import featureNames from '@utils/featureToggle/constants';
import NocFeatureCheck from '@src/pages/Noc/NocFeatureCheck';
import { homePagePath } from './index';

export const AppExperienceDashboardPage = (props) => {
  return (
    <FeatureToggle feature={featureNames.APP_EXPERIENCE} fallback={<PageNotFound />} checkRole>
      <WithResetTrends>
        <WithPersistence>
          <AppExperience {...props} />
        </WithPersistence>
      </WithResetTrends>
    </FeatureToggle>
  );
};

export const AppWebhooksListPage = () => {
  return (
    <FeatureToggle feature={featureNames.APP_WEBHOOKS} fallback={<PageNotFound />} checkRole>
      <WebhooksListPage />
    </FeatureToggle>
  );
};

export const AppWebhooksEditPage = (props) => {
  return (
    <FeatureToggle feature={featureNames.APP_WEBHOOKS} fallback={<PageNotFound />} checkRole>
      <WebhooksEditPage {...props} />
    </FeatureToggle>
  );
};

export const AppExperienceComparisonPage = (props) => {
  return (
    <FeatureToggle feature={featureNames.APP_EXPERIENCE} fallback={<PageNotFound />} checkRole>
      <CustomDashboard {...props} />
    </FeatureToggle>
  );
};

export const AppExperienceComparisonDrillDownPage = (props) => {
  return (
    <FeatureToggle feature={featureNames.APP_EXPERIENCE} fallback={<PageNotFound />} checkRole>
      <WithModifyComparison {...props}>
        <AppExperience />
      </WithModifyComparison>
    </FeatureToggle>
  );
};

export const AppExperienceTempDrilldownPage = (props) => {
  return (
    <FeatureToggle feature={featureNames.APP_EXPERIENCE} fallback={<PageNotFound />} checkRole>
      <TempAppExperienceDrilldown {...props} />
    </FeatureToggle>
  );
};

export const AppTimelinePage = (props) => {
  return (
    <FeatureToggle feature={featureNames.APP_USER_TIMELINE} fallback={<PageNotFound />} checkRole>
      <AppTimeline {...props} />
    </FeatureToggle>
  );
};

export const AppAiAlertsPage = (props) => (
  <FeatureToggle feature={featureNames.APP_AI_ALERTS} fallback={<PageNotFound />} checkRole>
    <AiAlertsDashboard {...props} />
  </FeatureToggle>
);

// error-diagnostics sharing feature toggle
export const ErrorDiagnosticsSharingRoute = (props) => (
  <FeatureToggle
    feature={featureNames.ERROR_DIAGNOSTICS}
    fallback={<Redirect to={homePagePath} />}
    checkRole
  >
    <ErrorDiagnosticsSharing {...props} />
  </FeatureToggle>
);

// error-diagnostics sharing feature toggle
export const TempDashboardErrorDiagnosticsRoute = (props) => (
  <FeatureToggle
    feature={featureNames.ERROR_DIAGNOSTICS}
    fallback={<Redirect to={homePagePath} />}
    checkRole
  >
    <TempDashboardErrorDiagnostics {...props} />
  </FeatureToggle>
);

export const DashboardErrorDiagnosticsRoute = (props) => (
  <FeatureToggle
    feature={featureNames.ERROR_DIAGNOSTICS}
    fallback={<Redirect to={homePagePath} />}
    checkRole
  >
    <DashboardErrorDiagnostics {...props} />
  </FeatureToggle>
);

export const TempTimelineRoute = (props) => (
  <FeatureToggle
    feature={featureNames.VIEWER_DRILLDOWN_TIMELINE}
    fallback={<Redirect to={homePagePath} />}
  >
    <TempTimeline {...props} />
  </FeatureToggle>
);

export const TimelineSharingRoute = (props) => (
  <FeatureToggle
    feature={featureNames.VIEWER_DRILLDOWN_TIMELINE}
    fallback={<Redirect to={homePagePath} />}
  >
    <TimelineSharing {...props} />
  </FeatureToggle>
);

export const SavedTimelineRoute = (props) => (
  <FeatureToggle
    feature={featureNames.VIEWER_DRILLDOWN_TIMELINE}
    fallback={<Redirect to={homePagePath} />}
  >
    <SavedTimeline {...props} />
  </FeatureToggle>
);

export const ViewerModulePage = (props) => (
  <FeatureToggle
    feature={featureNames.VIEWER_MODULE_PULSE5}
    fallback={<Redirect to={homePagePath} />}
  >
    <WithPersistence>
      <ViewerModule {...props} />
    </WithPersistence>
  </FeatureToggle>
);

export const NocPage = (props) => (
  <FeatureToggle feature={featureNames.NOC} fallback={<NocFeatureCheck {...props} />} checkRole>
    <WithPersistence>
      <NocContainer {...props} />
    </WithPersistence>
  </FeatureToggle>
);

export const NocSharingRoute = (props) => (
  <FeatureToggle
    feature={featureNames.NOC}
    fallback={<NocFeatureCheck {...props} pageType={PAGE_TYPE.SHARING} />}
    checkRole
  >
    <NocSharing {...props} />
  </FeatureToggle>
);

export const NocSavedDashboardBasedOnFF = (props) => (
  <FeatureToggle
    feature={featureNames.REALTIME_PSD}
    fallback={<DashboardNoc {...props} />}
    checkRole
  >
    <NocSavedDashboard {...props} />
  </FeatureToggle>
);

export const DashboardNocRoute = (props) => (
  <FeatureToggle
    feature={featureNames.NOC}
    fallback={<NocFeatureCheck {...props} pageType={PAGE_TYPE.SAVED_DASHBOARD} />}
    checkRole
  >
    <NocSavedDashboardBasedOnFF {...props} />
  </FeatureToggle>
);

export const TempDashboardNocRoute = (props) => (
  <FeatureToggle
    feature={featureNames.NOC}
    fallback={<NocFeatureCheck {...props} pageType={PAGE_TYPE.TEMP_DASHBOARD} />}
    checkRole
  >
    <TempDashboardNoc {...props} />
  </FeatureToggle>
);

export const MetricLensPage = (props) => (
  <FeatureToggle feature={featureNames.ML} fallback={<Redirect to={homePagePath} />} checkRole>
    <WithPersistence>
      <MLContainer {...props} />
    </WithPersistence>
  </FeatureToggle>
);

export const ExperienceDashboardPage = (props) => (
  <FeatureToggle
    feature={featureNames.EXPERIENCE_DASHBOARD}
    fallback={<Redirect to={homePagePath} />}
    checkRole
  >
    <WithPersistence>
      <OverviewDashboard {...props} />
    </WithPersistence>
  </FeatureToggle>
);

export const ServiceIntegrationsPage = () => <ServiceIntegrations homePagePath={homePagePath} />;

export const ResiliencyPolicyPage = () => <ResiliencyDashboard />;

export const AiAlertsPage = (props) => (
  <FeatureToggle
    feature={featureNames.AI_ALERTS_PULSE5}
    fallback={<Redirect to={homePagePath} />}
    checkRole
  >
    <AiAlertsDashboard {...props} />
  </FeatureToggle>
);

export const AppSankeyPage = (props) => <Sankey {...props} />;
export const AppFunnelPage = (props) => <Funnel {...props} />;
